import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {
  Col,
  UiQuestionnaireLayout,
  UiSlider,
  UiSliderFilledTrack,
  UiSliderMark,
  UiSliderThumb,
  UiSliderTrack,
  UiText,
} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_TWO_KEYS, WEIGHT_LOSS_TWO_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

const labelStyles = {
  mt: '-2.5',
  width: '0.5',
  height: '5',
  backgroundColor: 'white',
  zIndex: '1',
};

interface Props {}

const MDQ2Questionnaire5Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_TWO_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_TWO_KEYS.CURRENT_LIFESTYLE);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_TWO_KEYS.CURRENT_LIFESTYLE]?.data,
  );

  const collectedData = mdq.collectedData;

  const selectedOptionIndex = questionnaire?.options?.findIndex(i => i.value === currentAnswer?.selectedOption) || 0;

  const {inputs, setInputs, validation} = useInput({
    selectedOption: selectedOptionIndex > 0 ? selectedOptionIndex : 0,
  });

  const optionLength = questionnaire?.options?.length;
  //   const isLastOption = optionLength && inputs?.selectedOption === optionLength - 1;

  const onClickSubmit = () => {
    const selectedOption = questionnaire?.options?.[inputs?.selectedOption];
    const answerData = {
      key: WEIGHT_LOSS_TWO_KEYS.CURRENT_LIFESTYLE,
      index: questionnaire?.index || '',
      data: {
        selectedOption: selectedOption?.value,
      },
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_TWO_KEYS.CURRENT_LIFESTYLE]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.BMI_CALCULATOR}));
    history.push(PAGE_URLS.MDQ2_EATING_HABITS + window.location.search);
  };

  const renderDesc = () => {
    const desc = questionnaire?.options?.[inputs?.selectedOption];
    return (
      <>
        <UiText fontWeight={700} fontSize="lg" color="trueBlack" mb={4}>
          {desc?.label}
        </UiText>
        <UiText fontWeight={500} fontSize="sm" color="trueBlack">
          {desc?.description}
        </UiText>
      </>
    );
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      pageTitle={questionnaire?.title}
    >
      <Col textAlign="center" mt={20} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={14}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiSlider
          min={0}
          max={optionLength ? optionLength - 1 : 3}
          step={1}
          aria-label="slider-ex-1"
          defaultValue={inputs?.selectedOption}
          onChange={val => setInputs({selectedOption: val})}
          mb={10}
        >
          <UiSliderMark value={1} {...labelStyles}></UiSliderMark>
          <UiSliderMark value={2} {...labelStyles}></UiSliderMark>
          <UiSliderTrack bg="#EBF2C8" h={2} borderRadius={4}>
            <UiSliderFilledTrack bg="lightBaseColor" h={2} zIndex={1} />
          </UiSliderTrack>
          <UiSliderThumb style={{border: '2.5px solid #000000', width: '17px', height: '17px'}} />
        </UiSlider>
        {renderDesc()}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQ2Questionnaire5Screen;
